import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import AfitdConfirmDialog from './AfitdConfirmDialog';

const AfitdRouterPrompt = props => {
    const { when, onConfirm = () => true } = props;

    const history = useHistory();

    const [showPrompt, setShowPrompt] = useState(false);
    const [currentPath, setCurrentPath] = useState('');

    useEffect(() => {
        if (when) {
            history.block(prompt => {
                setCurrentPath(prompt.pathname);
                setShowPrompt(true);
                return false;
            });
        } else {
            history.block(() => {});
        }

        return () => {
            history.block(() => {});
        };
    }, [history, when]);

    const handleClickYes = useCallback(async () => {
        if (onConfirm) {
            const canRoute = await Promise.resolve(onConfirm());
            if (canRoute) {
                history.block(() => {});
                history.push(currentPath);
            }
        }
    }, [currentPath, history, onConfirm]);

    const handleClickNo = useCallback(() => {
        setShowPrompt(false);
    }, []);

    return showPrompt ? (
        <AfitdConfirmDialog title="Leave This Page?" onClose={handleClickNo} onConfirm={handleClickYes} open={showPrompt} message="All unsaved data will be lost." />
    ) : null;
};

export default AfitdRouterPrompt;
